import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";

export default function FormModal(props) {
  useEffect(() => {
    const modalElement = document.getElementById(props.modalId);
    if (!modalElement) return;

    const modal =
      bootstrap.Modal.getInstance(modalElement) ||
      new bootstrap.Modal(modalElement, {
        keyboard: false,
        backdrop: "static",
      });

    if (props.show) {
      modal.show();
    } else {
      modal.hide();
    }
  }, [props.show, props.modalId]);

  if (props.show) {
    return (
      <div className="modal fade" role="dialog" id={props.modalId}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{props.title}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => props.dismiss()}
              ></button>
            </div>
            <Form method="POST" action={props.action}>
              <div className="modal-body">
                <input
                  type="hidden"
                  name="authenticity_token"
                  value={document.querySelector('meta[name="csrf-token"]').getAttribute("content")}
                />
                {props.fields}
              </div>
              {["PATCH", "PUT", "DELETE"].includes(props.method) && (
                <input type="hidden" name="_method" value={props.method} />
              )}
              {props.hideActions ? null : (
                <div className="modal-footer">
                  <Button
                    variant={props.buttonType ?? "primary"}
                    type="submit"
                    {...props.primaryButtonProps}
                  >
                    {props.buttonText}
                  </Button>
                  {props.secondaryButtonText ? (
                    <Button
                      type="submit"
                      variant={props.secondaryButtonType ?? "danger"}
                      formAction={props.secondaryButtonAction}
                      formMethod="post"
                    >
                      {props.secondaryButtonText}
                    </Button>
                  ) : (
                    <button
                      type="button"
                      className="btn bg-white border"
                      data-bs-dismiss="modal"
                      onClick={props.dismiss}
                    >
                      Cancel
                    </button>
                  )}
                </div>
              )}
            </Form>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}
